// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as PilotPunctuation$LiteracyplanetTupperware from "./PilotPunctuation.res.mjs";
import * as TupperwareLayoutSwitch$LiteracyplanetTupperware from "./TupperwareLayoutSwitch.res.mjs";

function SkilfulPunctuation(props) {
  var questionIndex = props.questionIndex;
  var items = props.items;
  var id = props.id;
  TupperwareLayoutSwitch$LiteracyplanetTupperware.use() === "Pilot";
  return React.createElement(PilotPunctuation$LiteracyplanetTupperware.make, {
              id: id,
              items: items,
              questionIndex: questionIndex
            });
}

var make = SkilfulPunctuation;

var $$default = SkilfulPunctuation;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
